import Vue from 'vue';
import dayjs from 'dayjs';

/**
 * 格式化日期
 */
Vue.filter('formatDate', (date, format = 'YYYY-MM-DD HH:mm:ss') => dayjs(date).format(format));

/*
 * 金额千分位转化
*/
Vue.filter('formatMoney', (num) => {
  return num.toString().replace(/\d+/, (n) => {
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
      return $1 + ',' ;
    });
  });
});

/**
 * 数组对象属性拼接
 */
Vue.filter('joinArray', (data, prop) => data.map(item => item[prop]).join(', '));
